/* ============================================================
   Chesto — Homepage Bestsellers
   Reveal-on-scroll, rank count-up, mobile dot tracker.
   No framework dependency. Idempotent.
   ============================================================ */
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.bsInit === '1') return;
    section.dataset.bsInit = '1';

    /* ---------- Per-element entry reveal (header + cards) ---------- */
    var revealEls = section.querySelectorAll('[data-bs-reveal]');
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var ioReveal = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              ioReveal.unobserve(e.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        revealEls.forEach(function (el) { ioReveal.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }
      setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('is-in'); }); }, 1500);
    }

    /* ---------- Reveal-on-scroll (with safety-net) ---------- */
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      section.classList.add('is-revealed');
      runCountUps();
    }
    var safety = setTimeout(reveal, 350);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            clearTimeout(safety);
            reveal();
            io.disconnect();
          }
        });
      }, { threshold: 0.12 });
      io.observe(section);
    } else {
      // No IO support — reveal immediately.
      clearTimeout(safety);
      reveal();
    }

    /* ---------- Rank count-up ---------- */
    function runCountUps() {
      var targets = section.querySelectorAll('[data-bs-rank-target]');
      targets.forEach(function (el, i) {
        var target = parseInt(el.getAttribute('data-bs-rank-target'), 10) || 0;
        var dur = 700 + i * 60;
        var t0 = performance.now();
        function tick(t) {
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3); // ease-out-cubic
          el.textContent = String(Math.round(target * e));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }

    /* ---------- Mobile dots ---------- */
    var track = section.querySelector('[data-bs-track]');
    var dotsHost = section.querySelector('[data-bs-dots]');
    if (!track || !dotsHost) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-card="1"]'));
    if (!cards.length) return;

    // Build dots once
    dotsHost.innerHTML = '';
    cards.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bs-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Ga naar product ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: cards[i].offsetLeft - 24, behavior: 'smooth' });
      });
      dotsHost.appendChild(b);
    });
    var dots = Array.prototype.slice.call(dotsHost.children);

    function updateActiveDot() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      cards.forEach(function (c, i) {
        var cardCenter = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(cardCenter - center);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === bestIdx);
      });
    }

    var rafScroll = null;
    track.addEventListener('scroll', function () {
      if (rafScroll) return;
      rafScroll = requestAnimationFrame(function () {
        rafScroll = null;
        updateActiveDot();
      });
    }, { passive: true });

    window.addEventListener('resize', updateActiveDot);
    updateActiveDot();

    /* ---------- Add to cart — inline (no page reload) + success animation ---------- */
    section.querySelectorAll('form.bs-cta-form').forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        var notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!notif) return; // fall back to native submit
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) return;
        if (btn) btn.disabled = true;
        try {
          var body = new FormData(form);
          if (notif.getSectionsToRender) {
            body.append('sections', notif.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            body.append('sections_url', window.location.pathname);
          }
          var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
          var res = await fetch(url + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: body
          });
          var data = await res.json();
          if (res.ok) {
            if (notif.renderContents) notif.renderContents(data);
            if (btn) {
              btn.classList.add('is-added');
              setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
            }
          }
        } catch (err) {
          console.warn('[bestsellers] add-to-cart error:', err);
        } finally {
          if (btn) btn.disabled = false;
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bs-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in Shopify theme editor when sections are re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('[data-bs-section]') : null;
    if (s) init(s);
  });
})();
